import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { map, Observable } from "rxjs";
import { ApplicationContextService } from "src/app/services/application-context.service";

@Injectable({
  providedIn: 'root'
})
export class HasPpeAccessGuard  {

  constructor(private readonly _applicationContextService: ApplicationContextService,
    private readonly _router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._applicationContextService.context.pipe(map(context => {
      const pricingEnabled = context.userPermissions.pricingEnabled;
      if (!pricingEnabled) {
        this._router.navigateByUrl('tpo/dashboard');
        return false;
      }
      if (context.isCompanyPRMG) {
        const ppeChannels = context.userPermissions.ppeLoanChannels;
        if (!ppeChannels || ppeChannels.length === 0) {
          this._router.navigateByUrl('tpo/dashboard');
          return false;
        }
      }
      return true;
    }))
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
}
